module.exports = __webpack_public_path__ + "Uplayplus_LP_carousel_TC2_desktop.png";